const messages = {
  threads: {
    orders: {
      title: "Tu pedido en la tienda de recompensas",
      content:
        "Hola, <br/>Gracias por tu pedido en la tienda de recompensas.<br/>Tu pedido está siendo procesado.<br/>La entrega de tu pedido se producirá en un plazo aproximado de entre 7 y 15 días.<br/>(Nota: Todos los mensajes relacionados con tu pedido serán enviados por nuestro proveedor Talentum.)<br/>Saludos,<br/>Equipo de BRIDGESTONE PLUS",
    },
    externalTraining: { title: "", content: "" },
    InvestmentSupport: { title: "", content: "" },
    onlineTraining: { title: "", content: "" },
    bTraining: { title: "", content: "" },
    hunter: { title: "", content: "" },
    profileComplete: { title: "", content: "" },
    activeUser: {
      title: "Tu registro ha sido aprobado",
      content:
        "¡Bienvenido a BRIDGESTONE PLUS!<br/>Tu registro en BRIDGESTONE PLUS ha sido revisado y aprobado. Ya puedes disfrutar de todo lo que te ofrece BRIDGESTONE PLUS.<br/>Equipo BRIDGESTONE PLUS",
    },
    deleteItemFromOrder: { title: "", content: "" },
    deleteOrder: { title: "", content: "" },
    commitmentLetter: {
      title:
        "Bridgestone Rewards: Aceptación Términos y Condiciones / Política de Privacidad",
      content:
        "Estimado usuario de Bridgestone Plus,<br/>Gracias por aceptar los “Términos y Condiciones” así como la “Política de Privacidad” de participación. Esperamos que la plataforma Bridgestone Plus Rewards te resulte de gran utilidad.<br/>Cualquier duda que tengas, por favor, contáctanos a través del email que encontrarás en la sección de “Contacto”.<br/>Un saludo y muchas gracias,<br/>Equipo Bridgestone Plus",
    },
    uberall: { title: "", content: "" },
    welcome: {
      title:
        "Bridgestone: Aceptación Términos y Condiciones / Política de Privacidad",
      content:
        "Estimado usuario de Bridgestone Plus,<br>Gracias por aceptar los “Términos y Condiciones” así como la “Política de Privacidad” de participación. Esperamos que la plataforma Bridgestone Plus te resulte de gran utilidad.<br>Cualquier duda que tengas, por favor, contáctanos a través del email que encontrarás en la sección de “Contacto”.<br>Un saludo y muchas gracias,<br>Equipo Bridgestone Plus",
    },
    booster: { title: "", content: "" },
    orderStatus_RETURNED: { title: "", content: "" },
    orderStatus_REJECTED: { title: "", content: "" },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: { title: "", content: "" },
  },
};

export default {
  messages,
};
